import React from 'react';
import { closeModal } from 'actions/common';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import RSSModalMapper from './components/RSSModalMapper';
import RSSDialog from './components/RSSDialog';

const rssDialog = props => {
  const { modal, onCloseModal } = props;
  const showModal = !_.isEmpty(modal) && !_.isEmpty(modal.modalProps);
  return (
    <RSSDialog
      title={showModal ? modal.modalProps.title : ''}
      show={showModal}
      onClose={onCloseModal}
      modalSize={modal.modalProps.modalSize}
    >
      {modal && (
        <RSSModalMapper onClose={onCloseModal} {...modal} />
      )}
    </RSSDialog>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({
    modal: state.modal
  }),
  dispatch => bindActionCreators(
    {
      onCloseModal: closeModal
    },
    dispatch
  )
);

export const RSSDialogContainer = compose(
  withConnectState
)(rssDialog);
